// extracted by mini-css-extract-plugin
export var label = "_e8-2";
export var slideContainer = "_e8-0";
export var slider = "_e8-1";